<div class="text-center">
    <!-- <div class=""><b>Select Status</b></div> -->
    <div class="relative">
        <ng-select #statusSelect class="custom-ng-select" [items]="statusList" bindLabel="status_selected"
            [multiple]="false" [closeOnSelect]="true" [clearable]="true" [loading]="statusLoading"
            [typeahead]="statusInput$" typeToSearchText="" [virtualScroll]="true" [(ngModel)]="selectedStatus"
            [searchable]="false"></ng-select>
        <i class="fa fa-search" style="right: 17px !important;"></i>
    </div>
</div>